import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class AddWorkRequest extends GenericRequest {

    work;

    constructor(work) {
        super(METHOD_PUT, ApiEndpoints.WORKS);
        this.work = work;
    }

    overrideRequest() {
        return this.work;
    }
}



// WEBPACK FOOTER //
// ./src/app/works/ws/AddWorkRequest.js